module.exports = __webpack_public_path__ + "static/Itemfix-786487cc9d98df0ec9c3204aed3d46bb.jpg";